import { useTranslation } from "react-i18next";
import { Users } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { DatePicker } from "../ui/DatePicker";

const EmployeePersonalInfoSection = ({ formData, updateField }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Users className="h-4 w-4" />
        <span>{t("employeesPage.sections.personalInfo")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="matricule">{t("employeesPage.labels.registrationNumber")} *</Label>
          <Input id="matricule" placeholder={t("employeesPage.placeholders.registrationNumber")} value={formData.registration_number} onChange={(e) => updateField("registration_number", e.target.value)} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="nom">{t("employeesPage.labels.lastName")} *</Label>
          <Input id="nom" placeholder={t("employeesPage.placeholders.lastName")} value={formData.last_name} onChange={(e) => updateField("last_name", e.target.value)} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="prenom">{t("employeesPage.labels.firstName")}</Label>
          <Input id="prenom" placeholder={t("employeesPage.placeholders.firstName")} value={formData.first_name} onChange={(e) => updateField("first_name", e.target.value)} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="date_naissance">{t("employeesPage.labels.birthDate")}</Label>
          <DatePicker value={formData.birth_date} onChange={(v) => updateField("birth_date", v)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="code_badge">{t("employeesPage.labels.badgeNumber")}</Label>
          <Input id="code_badge" placeholder={t("employeesPage.labels.badgeNumber")} value={formData.badge_number} onChange={(e) => updateField("badge_number", e.target.value)} />
        </div>
        <div />
      </div>
    </div>
  );
};

export default EmployeePersonalInfoSection;
